import { actions } from './actions';
import * as sagas from './sagas';
export const appendixModel = { actions, sagas };
